export const GET_VENUES_STATUSES = 'GET_VENUES_STATUSES'
export const GET_VENUES_STATUSES_SUCCESS = 'GET_VENUES_STATUSES_SUCCESS'
export const GET_VENUES_STATUSES_ERROR = 'GET_VENUES_STATUSES_ERROR'

export const GetVenuesStatuses = (data) => ({
  type: GET_VENUES_STATUSES,
  payload: data
})
